import * as React from 'react';
import { useMemo } from 'react';
import NavShell from './NavShell';
import HomeIcon from '@mui/icons-material/Home';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import PaymentsIcon from '@mui/icons-material/Payments';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import AssessmentIcon from '@mui/icons-material/Assessment';

function ManagerNavBar({ children }) {
  const navItems = useMemo(() => [
    { key: 'home', label: 'Home', icon: <HomeIcon />, path: '/home' },
    { key: 'orders', label: 'Zamówienia', icon: <ShoppingCartIcon />, path: '/ManagerOrders' },
    { key: 'warehouse', label: 'Magazyn', icon: <WarehouseIcon />, path: '/ManagerWarehouse' },
    { key: 'gatekeeper', label: 'Obecności', icon: <EventAvailableIcon />, path: '/ManagerGateKeeper' },
    { key: 'settlements', label: 'Rozliczenia', icon: <PaymentsIcon />, path: '/ManagerSettlements' },
    { key: 'administration', label: 'Ustawienia', icon: <AdminPanelSettingsIcon />, path: '/ManagerAdministration' },
    { key: 'reports', label: 'Raporty', icon: <AssessmentIcon />, path: '/ManagerReports' },
  ], []);

  return (
    <NavShell
      storageKeyPrefix="manager"
      profileHref="/ManagerProfile"
      allowedProfileTypes={['manager']}
      navItems={navItems}
    >
      {children}
    </NavShell>
  );
}

export default ManagerNavBar;
